module.exports = __webpack_public_path__ + "static/cfo-tech-outlook-6841a279c8eeb8723bc76a4fc4a9e16a.png";